import styled from "styled-components";

export const Nav = styled.nav`
  margin-bottom: ${props => props.theme.Grid.GutterSize};
  flex-shrink: 0;
`